import { useMemo } from 'react'

import { getProjectPanelAspect } from '../../lib/comicProjectSettings'
import { buildReaderEpisodeMap, buildReaderPageEntries } from '../../lib/comicReaderModel'
import type { ComicProject } from '../../lib/comicTypes'
import { ComicReaderOverlay } from './reader/ComicReaderOverlay'
import { ComicReaderShell } from './reader/ComicReaderShell'

type Props = {
  open: boolean
  angular: boolean
  project: ComicProject
  onClose: () => void
  onNavigate?: (episodeId: string, pageId: string, panelId?: string) => void
}

export function ComicProjectReaderModal({
  open,
  angular,
  project,
  onClose,
  onNavigate,
}: Props) {
  const entries = useMemo(() => buildReaderPageEntries(project), [project])
  const episodesById = useMemo(() => buildReaderEpisodeMap(project), [project])
  const panelAspect = getProjectPanelAspect(project)

  return (
    <ComicReaderOverlay
      open={open}
      angular={angular}
      title={project.title}
      subtitle="作品预览"
      onClose={onClose}
    >
      <ComicReaderShell
        angular={angular}
        entries={entries}
        episodesById={episodesById}
        panelAspect={panelAspect}
        onNavigatePage={onNavigate}
      />
    </ComicReaderOverlay>
  )
}
